const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Type+Ahead+Search+API

function searchTypeAhead(query, includeOnlyProducts = false) {
    const constructorSessionID = !!global.ConstructorioTracker && global.ConstructorioTracker.getSessionID();
    const constructorClientID = !!global.ConstructorioTracker && global.ConstructorioTracker.getClientID();
    const isNLPSearchEnabled = Sephora.configurationSettings.isNLPSearchEnabled;
    const isNLPInstrumentationEnabled = Sephora.configurationSettings.isNLPInstrumentationEnabled;
    const lastParam = includeOnlyProducts ? '&includeOnlyProducts=true' : '';
    let url = `/api/catalog/search/?type=typeahead&q=${encodeURIComponent(query)}${lastParam}`;
 
    if (isNLPInstrumentationEnabled){
        if (isNLPSearchEnabled && constructorSessionID && constructorClientID) {
            url = url + `&constructorSessionID=${constructorSessionID}&constructorClientID=${constructorClientID}&targetSearchEngine=nlp`;         
        }
    } else {
        url = url + '&targetSearchEngine=nlp';       
    }
   
    return ufeApi.makeRequest(url, { method: 'GET' }).
        then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = searchTypeAhead;
